module.exports = __webpack_public_path__ + "static/img/9.28ad905.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/9.png
// module id = 3k1u
// module chunks = 0